export default __webpack_public_path__ + "static/media/ReportesWhite.e7971d90.svg";